export const trackEvent = (eventName, params = {}) => {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", eventName, params);
};

// Iscrizione newsletter
export const trackNewsletterSignup = () =>
  trackEvent("newsletter_signup", { event_category: "engagement" });

// Invio modulo contatti
export const trackContactForm = () =>
  trackEvent("contact_form_submit", { event_category: "engagement" });

// Click sponsor
export const trackSponsorClick = (sponsorName, tier) =>
  trackEvent("sponsor_click", {
    event_category: "sponsor",
    event_label: sponsorName,
    sponsor_tier: tier,
  });

// Click condivisione news
export const trackShare = (method, articleTitle) =>
  trackEvent("share", {
    method,
    content_type: "article",
    event_label: articleTitle,
  });